//员工减除费用扣除确认

import { $http, buildHeaders } from "./index";

//获取列表
export const deductionamount_list = (params) => {
  return $http.get("/admin/DeductionAmount/index", { params });
};

//从税局更新数据
export const deductionamount_pull = (data) => {
  return $http.post("/admin/DeductionAmount/pull", data, {
    headers: buildHeaders(3),
  });
};

//获取操作记录
export const deductionamount_log = (params) => {
  return $http.get("/admin/DeductionAmount/log", {
    params,
    headers: buildHeaders(3),
  });
};

//将数据更新至税局
export const deductionamount_push = (data) => {
  return $http.post("/admin/DeductionAmount/push", data, {
    headers: buildHeaders(1),
  });
};

//更改扣除状态
export const deductionamount_update = (data) => {
  return $http.post("/admin/DeductionAmount/updateKcbs", data, {
    headers: buildHeaders(3),
  });
};

//删除
export const deductionamount_del = (data) => {
  return $http.post("/admin/DeductionAmount/del", data, {
    headers: buildHeaders(3),
  });
};

//导出
export const deductionamount_export = (params) => {
  return $http.get("/admin/DeductionAmount/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

